<template>
  <div class="py-4 container-fluid">
    <!-- Cabeçalho Principal -->
    <div class="card shadow-lg mb-3" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
      <div class="card-body p-3 text-center">
        <h4 class="text-white font-weight-bold mb-1">Controle de Treino do Personal</h4>
        <p class="text-white mb-0 text-sm">Gestão completa de alunos e treinos</p>
      </div>
    </div>

    <!-- Navegação de Período -->
    <div class="card shadow-lg mb-3" style="background: linear-gradient(to right, #e0e7ff, #fef3c7);">
      <div class="card-body p-2">
        <div class="row align-items-center g-2">
          <div class="col-auto">
            <button @click="navigateWeek(-1)" class="btn btn-white btn-sm shadow-sm">
              <i class="fas fa-chevron-left"></i>
            </button>
          </div>
          <div class="col text-center">
            <h6 class="mb-0 font-weight-bold" style="color: #4f46e5;">
              {{ viewMode === 'week' ? `Semana: ${weekStart} - ${weekEnd}` :
                 viewMode === 'month' ? `Mês: ${currentMonthName}` :
                 `Plano/Período` }}
            </h6>
          </div>
          <div class="col-auto">
            <div class="btn-group btn-group-sm" role="group">
              <!-- Botão Semana só aparece quando NÃO tem aluno selecionado -->
              <button v-if="!hasSelectedStudent" @click="viewMode = 'week'" :class="['btn btn-sm', viewMode === 'week' ? 'btn-primary' : 'btn-outline-primary']">
                Semana
              </button>
              <button @click="viewMode = 'month'" :class="['btn btn-sm', viewMode === 'month' ? 'btn-primary' : 'btn-outline-primary']">
                Mês
              </button>
              <button @click="viewMode = 'plan'" :class="['btn btn-sm', viewMode === 'plan' ? 'btn-primary' : 'btn-outline-primary']">
                Plano
              </button>
            </div>
          </div>
          <div class="col-auto">
            <button @click="goToToday()" class="btn btn-white btn-sm shadow-sm">
              Hoje
            </button>
          </div>
          <div class="col-auto">
            <button @click="navigateWeek(1)" class="btn btn-white btn-sm shadow-sm">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- CALENDÁRIO DO MÊS - Aparece quando modo Mês está selecionado com aluno -->
    <div v-if="viewMode === 'month' && hasSelectedStudent" class="card shadow-lg mb-3">
      <div class="card-body p-3">
        <!-- Título e botão toggle -->
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h6 class="mb-0 font-weight-bold text-primary">
            <i class="fas fa-calendar-alt me-2"></i>
            Calendário do Mês
          </h6>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="showMonthCalendar = !showMonthCalendar"
          >
            <i :class="showMonthCalendar ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            {{ showMonthCalendar ? 'Ocultar' : 'Visualizar' }}
          </button>
        </div>

        <!-- Calendário Visual do Mês - Formato Grande -->
        <div v-if="showMonthCalendar" class="calendario-mes-grande-container">
          <!-- Cabeçalho do Calendário com navegação -->
          <div class="calendario-mes-grande-header">
            <button @click="navigateCalendarMonth(-1)" class="btn btn-sm btn-outline-secondary">
              <i class="fas fa-chevron-left"></i>
            </button>
            <h5 class="mb-0 font-weight-bold text-primary">
              {{ monthCalendarData.monthName }} {{ monthCalendarData.year }}
            </h5>
            <button @click="navigateCalendarMonth(1)" class="btn btn-sm btn-outline-secondary">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>

          <!-- Dias da semana -->
          <div class="calendario-mes-grande-dias-header">
            <div class="dia-header">Segunda-feira</div>
            <div class="dia-header">Terça-feira</div>
            <div class="dia-header">Quarta-feira</div>
            <div class="dia-header">Quinta-feira</div>
            <div class="dia-header">Sexta-feira</div>
            <div class="dia-header">Sábado</div>
            <div class="dia-header">Domingo</div>
          </div>

          <!-- Grid do calendário -->
          <div class="calendario-mes-grande-grid">
            <template v-for="(semana, sIndex) in monthCalendarDataReordered.weeks" :key="sIndex">
              <div
                v-for="(dia, dIndex) in semana"
                :key="dIndex"
                :class="['dia-mes-grande', getDiaClassGrande(dia)]"
                :title="getDiaTooltip(dia)"
              >
                <span class="dia-numero">{{ dia.numero || '' }}</span>
                <div v-if="dia.numero && !dia.vazio && dia.data && !dia.foraPeriodo" class="dia-info">
                  <!-- ✅ Select de Status para cada dia dentro do período do plano -->
                  <select
                    class="form-select form-select-sm status-select-dia"
                    :class="getStatusSelectClass(dia.data)"
                    :value="getStatusForDate(dia.data)"
                    @change="onStatusSelectChange($event, dia.data)"
                    @click.stop
                  >
                    <option value="none">Selecione</option>
                    <option value="scheduled">Previsto</option>
                    <option value="executed">Executado</option>
                    <option value="incomplete">Incompleto</option>
                    <option value="not_executed">Não Exec.</option>
                    <option value="excess">Excedente</option>
                    <option value="vacation">Férias</option>
                  </select>
                  <!-- Botões de ação -->
                  <div class="dia-acoes-btns">
                    <!-- Botão de observação -->
                    <button
                      class="btn-note-dia"
                      :class="{ 'has-note': getNoteForDate(dia.data) }"
                      @click.stop="openNoteModal(dia.data)"
                      :title="getNoteForDate(dia.data) || 'Adicionar observação'"
                    >
                      <i :class="getNoteForDate(dia.data) ? 'fas fa-sticky-note' : 'far fa-sticky-note'"></i>
                    </button>
                    <!-- Botão ir para área do aluno -->
                    <button
                      class="btn-exercicios-dia"
                      @click.stop="goToStudentArea(dia.data)"
                      title="Ver exercícios na área do aluno"
                    >
                      <i class="fas fa-dumbbell"></i>
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <!-- Legenda -->
          <div class="legenda-plano mt-3">
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-previsto-plano"></span>
              Previsto
            </span>
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-executado-plano"></span>
              Executado
            </span>
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-incompleto-plano"></span>
              Incompleto
            </span>
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-nao-executado-plano"></span>
              Não Executado
            </span>
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-ferias-plano"></span>
              Férias
            </span>
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-excedente-plano"></span>
              Excedente
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- CALENDÁRIOS DO PLANO - Aparecem quando modo Plano está selecionado E aluno selecionado -->
    <div v-if="viewMode === 'plan' && hasSelectedStudent && planCalendarData.months.length > 0" class="card shadow-lg mb-3">
      <div class="card-body p-3">
        <!-- Título e botão toggle -->
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h6 class="mb-0 font-weight-bold text-primary">
            <i class="fas fa-calendar-alt me-2"></i>
            Calendário do Plano
          </h6>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="showPlanCalendars = !showPlanCalendars"
          >
            <i :class="showPlanCalendars ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            {{ showPlanCalendars ? 'Ocultar' : 'Visualizar' }}
          </button>
        </div>

        <!-- Calendários Visuais -->
        <div v-if="showPlanCalendars" class="calendarios-plano-container">
          <div class="d-flex flex-wrap justify-content-center calendario-meses-wrapper">
            <div
              v-for="(mesData, index) in planCalendarData.months"
              :key="index"
              class="calendario-plano-mes"
            >
              <div class="calendario-plano-header">
                {{ mesData.nome }}
              </div>
              <div class="calendario-plano-dias-header">
                <span>D</span>
                <span>S</span>
                <span>T</span>
                <span>Q</span>
                <span>Q</span>
                <span>S</span>
                <span>S</span>
              </div>
              <div class="calendario-plano-grid">
                <template v-for="(semana, sIndex) in mesData.semanas" :key="sIndex">
                  <span
                    v-for="(dia, dIndex) in semana"
                    :key="dIndex"
                    :class="[getDiaClass(dia), dia.numero && !dia.vazio && !dia.foraPeriodo ? 'dia-plano-clicavel' : '']"
                    :title="getDiaTooltip(dia)"
                    @click="dia.numero && !dia.vazio && !dia.foraPeriodo && dia.data ? openCalendarStatusMenu(dia.data) : null"
                  >
                    {{ dia.numero || '' }}
                  </span>
                </template>
              </div>
            </div>
          </div>

          <!-- Legenda -->
          <div class="legenda-plano mt-3">
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-previsto-plano"></span>
              Previsto
            </span>
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-executado-plano"></span>
              Executado
            </span>
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-incompleto-plano"></span>
              Incompleto
            </span>
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-nao-executado-plano"></span>
              Não Executado
            </span>
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-ferias-plano"></span>
              Férias
            </span>
            <span class="legenda-plano-item">
              <span class="legenda-plano-cor bg-excedente-plano"></span>
              Excedente
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabela de Agenda - Só aparece quando NÃO tem aluno selecionado -->
    <div v-if="!hasSelectedStudent" class="card shadow-lg overflow-hidden">
      <div class="table-responsive">
        <table class="table table-bordered mb-0">
          <!-- Cabeçalho com Degradê -->
          <thead>
            <tr style="background: linear-gradient(to right, #4f46e5, #7c3aed, #a855f7, #c026d3, #db2777, #f97316, #fb923c);">
              <th v-if="!hasSelectedStudent" class="text-white text-center font-weight-bold p-2 sticky-col sticky-header" style="width: 200px; font-size: 0.85rem;">Aluno</th>
              <th
                v-for="(day, index) in displayDays"
                :key="index"
                class="text-white text-center font-weight-bold p-2"
                style="min-width: 100px; font-size: 0.85rem;"
              >
                {{ day.label }}
              </th>
            </tr>
          </thead>

          <tbody>
            <!-- Linha para cada aluno -->
            <template v-for="(student, studentIndex) in students" :key="student.id">
              <tr :class="studentIndex % 2 === 0 ? 'bg-white' : 'bg-light'">
                <!-- Coluna do Aluno (oculta quando aluno está selecionado) -->
                <td v-if="!hasSelectedStudent" class="p-2 sticky-col" :class="studentIndex % 2 === 0 ? 'bg-white' : 'bg-light'">
                  <div class="d-flex flex-column">
                    <p class="mb-1 font-weight-bold text-primary" style="font-size: 0.85rem;">{{ student.name }}</p>
                    <p class="text-xs mb-1"><strong>{{ student.weeklyClasses}}x/sem</strong> | {{ student.trainDays ? student.trainDays.join(', ') : '' }}</p>
                    <p class="text-xs text-muted mb-2">
                      {{ student.startDate ? formatDateBR(student.startDate) : '' }} - {{ student.endDate ? formatDateBR(student.endDate) : '' }}
                    </p>
                    <button
                      @click="toggleStatistics(student.id)"
                      class="btn btn-sm w-100 shadow-sm"
                      :class="showStatistics === student.id ? 'btn-danger' : 'btn-primary'"
                      style="font-size: 0.75rem; padding: 4px 8px;"
                    >
                      <i :class="['fas', showStatistics === student.id ? 'fa-eye-slash' : 'fa-chart-bar']"></i>
                      {{ showStatistics === student.id ? 'Ocultar' : 'Ver Estatística' }}
                    </button>
                  </div>
                </td>

                <!-- Células dos Dias -->
                <td
                  v-for="(dayInfo, dayIndex) in displayDays"
                  :key="`${student.id}-${dayIndex}`"
                  @click="toggleStatusMenu(student.id, dayInfo.date)"
                  :class="[
                    'text-center p-2 cursor-pointer position-relative',
                    getStatusClass(student.id, dayInfo.date),
                    isToday(dayInfo.date) ? 'border border-primary border-2' : ''
                  ]"
                  style="cursor: pointer; min-height: 70px; vertical-align: middle;"
                >
                  <div class="d-flex flex-column align-items-center justify-content-center h-100">
                    <span class="h3 text-white mb-1">
                      {{ getStatusIcon(student.id, dayInfo.date) }}
                    </span>
                    <span class="text-xs" style="color: #333;">
                      {{ formatDateShort(dayInfo.date) }}
                    </span>
                    <span
                      v-if="getStatus(student.id, dayInfo.date) !== 'none'"
                      class="text-xs text-white font-weight-bold mt-1"
                    >
                      {{ getStatusLabel(student.id, dayInfo.date) }}
                    </span>
                  </div>

                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <!-- Painel de Estatísticas (dentro da tabela - modo semana/lista) -->
      <template v-for="student in students" :key="`stats-${student.id}`">
        <div v-if="showStatistics === student.id" class="p-3 bg-light border-top">
          <div class="card bg-white border-0 shadow-sm">
            <div class="card-body p-2">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="mb-0 font-weight-bold text-dark" style="font-size: 0.9rem;">Resumo Geral</h6>
                <div class="d-flex gap-2">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    @click="showResumoGeral = !showResumoGeral"
                  >
                    <i :class="showResumoGeral ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    {{ showResumoGeral ? 'Ocultar' : 'Visualizar' }}
                  </button>
                  <button
                    @click="sendReport(student)"
                    class="btn btn-success btn-sm shadow-sm"
                    style="font-size: 0.75rem;"
                  >
                    <i class="fas fa-paper-plane"></i> Enviar
                  </button>
                </div>
              </div>

              <div v-if="showResumoGeral" class="row g-2">
                <!-- Resumo do Mês -->
                <div class="col-md-6 mb-3">
                  <div class="card bg-gradient-light border-0">
                    <div class="card-body p-2">
                      <h6 class="font-weight-bold mb-2 text-secondary">Resumo Do Mês</h6>
                      <table class="table table-sm mb-0" style="font-size: 0.75rem;">
                        <tbody>
                          <tr>
                            <td class="text-muted">Treinos previstos no mês</td>
                            <td class="text-end font-weight-bold">{{ getMonthStats(student).scheduled }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Aulas contratadas neste mês</td>
                            <td class="text-end font-weight-bold">{{ getMonthStats(student).contracted }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos executados</td>
                            <td class="text-end font-weight-bold text-success">{{ getMonthStats(student).executed }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos não executados</td>
                            <td class="text-end font-weight-bold text-danger">{{ getMonthStats(student).notExecuted }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos incompletos</td>
                            <td class="text-end font-weight-bold text-warning">{{ getMonthStats(student).incomplete }}</td>
                          </tr>
                          <tr class="table-info">
                            <td class="font-weight-bold">Treinos excedentes (mês atual)</td>
                            <td class="text-end font-weight-bold">{{ getMonthStats(student).excess }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Resumo do Plano -->
                <div class="col-md-6 mb-3">
                  <div class="card bg-gradient-light border-0">
                    <div class="card-body p-2">
                      <h6 class="font-weight-bold mb-2 text-secondary">Resumo Do Plano</h6>
                      <table class="table table-sm mb-0" style="font-size: 0.75rem;">
                        <tbody>
                          <tr>
                            <td class="text-muted">Treinos previstos no plano atual</td>
                            <td class="text-end font-weight-bold">{{ getPlanStats(student).scheduled }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Aulas contratadas no plano atual</td>
                            <td class="text-end font-weight-bold">{{ getPlanStats(student).contracted }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos executados</td>
                            <td class="text-end font-weight-bold text-success">{{ getPlanStats(student).executed }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos não executados</td>
                            <td class="text-end font-weight-bold text-danger">{{ getPlanStats(student).notExecuted }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos incompletos</td>
                            <td class="text-end font-weight-bold text-warning">{{ getPlanStats(student).incomplete }}</td>
                          </tr>
                          <tr class="table-info">
                            <td class="font-weight-bold">Treinos excedentes (plano atual)</td>
                            <td class="text-end font-weight-bold">{{ getPlanStats(student).excess }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Resumo do Ano -->
                <div class="col-md-6">
                  <div class="card bg-gradient-light border-0">
                    <div class="card-body p-2">
                      <h6 class="font-weight-bold mb-2 text-secondary">Resumo Do Ano (2025)</h6>
                      <table class="table table-sm mb-0" style="font-size: 0.75rem;">
                        <tbody>
                          <tr>
                            <td class="text-muted">Aulas contratadas neste ano</td>
                            <td class="text-end font-weight-bold">{{ getYearStats(student).contracted }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos executados</td>
                            <td class="text-end font-weight-bold text-success">{{ getYearStats(student).executed }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos não executados</td>
                            <td class="text-end font-weight-bold text-danger">{{ getYearStats(student).notExecuted }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos incompletos</td>
                            <td class="text-end font-weight-bold text-warning">{{ getYearStats(student).incomplete }}</td>
                          </tr>
                          <tr class="table-info">
                            <td class="font-weight-bold">Treinos excedentes (ano atual)</td>
                            <td class="text-end font-weight-bold">{{ getYearStats(student).excess }}</td>
                          </tr>
                          <tr class="table-primary">
                            <td class="font-weight-bold">Gasto calórico acumulado neste ano</td>
                            <td class="text-end font-weight-bold">{{ getYearStats(student).calories }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">PSE médio</td>
                            <td class="text-end font-weight-bold">{{ getYearStats(student).pseAverage }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">PSR médio</td>
                            <td class="text-end font-weight-bold">{{ getYearStats(student).psrAverage }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Resumo Acumulado Total -->
                <div class="col-md-6">
                  <div class="card bg-gradient-light border-0">
                    <div class="card-body p-2">
                      <h6 class="font-weight-bold mb-2 text-secondary">Resumo Acumulado Total</h6>
                      <table class="table table-sm mb-0" style="font-size: 0.75rem;">
                        <tbody>
                          <tr>
                            <td class="text-muted">Aulas contratadas (histórico completo)</td>
                            <td class="text-end font-weight-bold">{{ getTotalStats(student).contracted }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos executados</td>
                            <td class="text-end font-weight-bold text-success">{{ getTotalStats(student).executed }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos não executados</td>
                            <td class="text-end font-weight-bold text-danger">{{ getTotalStats(student).notExecuted }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">Treinos incompletos</td>
                            <td class="text-end font-weight-bold text-warning">{{ getTotalStats(student).incomplete }}</td>
                          </tr>
                          <tr class="table-info">
                            <td class="font-weight-bold">Treinos excedentes (histórico completo)</td>
                            <td class="text-end font-weight-bold">{{ getTotalStats(student).excess }}</td>
                          </tr>
                          <tr class="table-primary">
                            <td class="font-weight-bold">Gasto calórico acumulado (histórico completo)</td>
                            <td class="text-end font-weight-bold">{{ getTotalStats(student).calories }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">PSE médio</td>
                            <td class="text-end font-weight-bold">{{ getTotalStats(student).pseAverage }}</td>
                          </tr>
                          <tr>
                            <td class="text-muted">PSR médio</td>
                            <td class="text-end font-weight-bold">{{ getTotalStats(student).psrAverage }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- RESUMO GERAL - Quando aluno selecionado no modo Mês ou Plano -->
    <template v-if="hasSelectedStudent && (viewMode === 'month' || viewMode === 'plan')">
      <div v-for="student in students" :key="`resumo-${student.id}`" class="card shadow-lg mt-3">
        <div class="card-body p-3">
          <!-- Cabeçalho -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0 font-weight-bold text-dark">Resumo Geral</h6>
            <div class="d-flex gap-2">
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="showResumoGeral = !showResumoGeral"
              >
                <i :class="showResumoGeral ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                {{ showResumoGeral ? 'Ocultar' : 'Visualizar' }}
              </button>
              <button
                @click="sendReport(student)"
                class="btn btn-success btn-sm shadow-sm"
              >
                <i class="fas fa-paper-plane"></i> Enviar
              </button>
            </div>
          </div>

          <div v-if="showResumoGeral">
            <div class="row g-3">
              <!-- Resumo por mês (do calendário) - Largura total -->
              <div class="col-12">
                <div class="card border-0 shadow-sm" style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);">
                  <div class="card-body p-3">
                    <h6 class="font-weight-bold mb-3 text-dark">
                      <i class="fas fa-calendar-check me-2 text-primary"></i>
                      Resumo por mês
                    </h6>
                    <div class="d-flex justify-content-center">
                      <!-- Tabela de resumo por mês usando dados do KPI do backend -->
                      <table v-if="getKpiResumoPorMes(student).length > 0" class="table table-sm table-bordered mb-0 bg-white" style="font-size: 0.85rem;">
                        <thead>
                          <tr class="table-light">
                            <th class="py-2 px-2">Mês</th>
                            <th class="text-center py-2 px-2">Previstos</th>
                            <th class="text-center py-2 px-2">Contratados</th>
                            <th class="text-center py-2 px-2">Executados</th>
                            <th class="text-center py-2 px-2">Não Exec.</th>
                            <th class="text-center py-2 px-2">Incompletos</th>
                            <th class="text-center py-2 px-2">Excedentes</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(mes, index) in getKpiResumoPorMes(student)" :key="index">
                            <td class="text-muted py-2 px-2">{{ mes.nome }}</td>
                            <td class="text-center text-primary font-weight-bold py-2 px-2">{{ mes.previstos }}</td>
                            <td class="text-center font-weight-bold py-2 px-2">{{ mes.contratados }}</td>
                            <td class="text-center text-success font-weight-bold py-2 px-2">{{ mes.executados }}</td>
                            <td class="text-center text-danger font-weight-bold py-2 px-2">{{ mes.naoExecutados }}</td>
                            <td class="text-center text-warning font-weight-bold py-2 px-2">{{ mes.incompletos }}</td>
                            <td class="text-center font-weight-bold py-2 px-2">{{ mes.excedentes }}</td>
                          </tr>
                          <tr class="table-info">
                            <td class="font-weight-bold py-2 px-2">Total (Plano):</td>
                            <td class="text-center font-weight-bold py-2 px-2">{{ getKpiResumoPorMesTotais(student).totalPrevistos }}</td>
                            <td class="text-center font-weight-bold py-2 px-2">{{ getKpiResumoPorMesTotais(student).totalContratados }}</td>
                            <td class="text-center font-weight-bold text-success py-2 px-2">{{ getKpiResumoPorMesTotais(student).totalExecutados }}</td>
                            <td class="text-center font-weight-bold text-danger py-2 px-2">{{ getKpiResumoPorMesTotais(student).totalNaoExecutados }}</td>
                            <td class="text-center font-weight-bold text-warning py-2 px-2">{{ getKpiResumoPorMesTotais(student).totalIncompletos }}</td>
                            <td class="text-center font-weight-bold py-2 px-2">{{ getKpiResumoPorMesTotais(student).totalExcedentes }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-else class="text-muted text-center py-3">
                        <i class="fas fa-spinner fa-spin me-2"></i>
                        Carregando dados do resumo...
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Resumo do Mês -->
              <div class="col-md-6">
                <div class="card border-0 shadow-sm h-100" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);">
                  <div class="card-body p-3">
                    <h6 class="font-weight-bold mb-3 text-dark">
                      <i class="fas fa-calendar-day me-2 text-info"></i>
                      Resumo Do Mês
                    </h6>
                    <table class="table table-sm mb-0 bg-white" style="font-size: 0.8rem;">
                      <tbody>
                        <tr>
                          <td class="text-muted">Treinos previstos no mês</td>
                          <td class="text-end font-weight-bold">{{ getMonthStats(student).scheduled }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Aulas contratadas neste mês</td>
                          <td class="text-end font-weight-bold">{{ getMonthStats(student).contracted }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos executados</td>
                          <td class="text-end font-weight-bold text-success">{{ getMonthStats(student).executed }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos não executados</td>
                          <td class="text-end font-weight-bold text-danger">{{ getMonthStats(student).notExecuted }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos incompletos</td>
                          <td class="text-end font-weight-bold text-warning">{{ getMonthStats(student).incomplete }}</td>
                        </tr>
                        <tr class="table-info">
                          <td class="font-weight-bold">Treinos excedentes (mês atual)</td>
                          <td class="text-end font-weight-bold">{{ getMonthStats(student).excess }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Resumo do Plano -->
              <div class="col-md-6">
                <div class="card border-0 shadow-sm h-100" style="background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);">
                  <div class="card-body p-3">
                    <h6 class="font-weight-bold mb-3 text-dark">
                      <i class="fas fa-clipboard-list me-2 text-purple"></i>
                      Resumo Do Plano
                    </h6>
                    <table class="table table-sm mb-0 bg-white" style="font-size: 0.8rem;">
                      <tbody>
                        <tr>
                          <td class="text-muted">Treinos previstos no plano atual</td>
                          <td class="text-end font-weight-bold">{{ getPlanStats(student).scheduled }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Aulas contratadas no plano atual</td>
                          <td class="text-end font-weight-bold">{{ getPlanStats(student).contracted }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos executados</td>
                          <td class="text-end font-weight-bold text-success">{{ getPlanStats(student).executed }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos não executados</td>
                          <td class="text-end font-weight-bold text-danger">{{ getPlanStats(student).notExecuted }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos incompletos</td>
                          <td class="text-end font-weight-bold text-warning">{{ getPlanStats(student).incomplete }}</td>
                        </tr>
                        <tr class="table-info">
                          <td class="font-weight-bold">Treinos excedentes (plano atual)</td>
                          <td class="text-end font-weight-bold">{{ getPlanStats(student).excess }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Resumo do Ano -->
              <div class="col-md-6">
                <div class="card border-0 shadow-sm h-100" style="background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);">
                  <div class="card-body p-3">
                    <h6 class="font-weight-bold mb-3 text-dark">
                      <i class="fas fa-calendar-alt me-2 text-success"></i>
                      Resumo Do Ano (2025)
                    </h6>
                    <table class="table table-sm mb-0 bg-white" style="font-size: 0.8rem;">
                      <tbody>
                        <tr>
                          <td class="text-muted">Aulas contratadas neste ano</td>
                          <td class="text-end font-weight-bold">{{ getYearStats(student).contracted }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos executados</td>
                          <td class="text-end font-weight-bold text-success">{{ getYearStats(student).executed }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos não executados</td>
                          <td class="text-end font-weight-bold text-danger">{{ getYearStats(student).notExecuted }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos incompletos</td>
                          <td class="text-end font-weight-bold text-warning">{{ getYearStats(student).incomplete }}</td>
                        </tr>
                        <tr class="table-info">
                          <td class="font-weight-bold">Treinos excedentes (ano atual)</td>
                          <td class="text-end font-weight-bold">{{ getYearStats(student).excess }}</td>
                        </tr>
                        <tr class="table-primary">
                          <td class="font-weight-bold">Gasto calórico acumulado neste ano</td>
                          <td class="text-end font-weight-bold">{{ getYearStats(student).calories }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">PSE médio</td>
                          <td class="text-end font-weight-bold">{{ getYearStats(student).pseAverage }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">PSR médio</td>
                          <td class="text-end font-weight-bold">{{ getYearStats(student).psrAverage }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Resumo Acumulado Total -->
              <div class="col-md-6">
                <div class="card border-0 shadow-sm h-100" style="background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);">
                  <div class="card-body p-3">
                    <h6 class="font-weight-bold mb-3 text-dark">
                      <i class="fas fa-chart-line me-2 text-warning"></i>
                      Resumo Acumulado Total
                    </h6>
                    <table class="table table-sm mb-0 bg-white" style="font-size: 0.8rem;">
                      <tbody>
                        <tr>
                          <td class="text-muted">Aulas contratadas (histórico completo)</td>
                          <td class="text-end font-weight-bold">{{ getTotalStats(student).contracted }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos executados</td>
                          <td class="text-end font-weight-bold text-success">{{ getTotalStats(student).executed }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos não executados</td>
                          <td class="text-end font-weight-bold text-danger">{{ getTotalStats(student).notExecuted }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Treinos incompletos</td>
                          <td class="text-end font-weight-bold text-warning">{{ getTotalStats(student).incomplete }}</td>
                        </tr>
                        <tr class="table-info">
                          <td class="font-weight-bold">Treinos excedentes (histórico completo)</td>
                          <td class="text-end font-weight-bold">{{ getTotalStats(student).excess }}</td>
                        </tr>
                        <tr class="table-primary">
                          <td class="font-weight-bold">Gasto calórico acumulado (histórico completo)</td>
                          <td class="text-end font-weight-bold">{{ getTotalStats(student).calories }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">PSE médio</td>
                          <td class="text-end font-weight-bold">{{ getTotalStats(student).pseAverage }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">PSR médio</td>
                          <td class="text-end font-weight-bold">{{ getTotalStats(student).psrAverage }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- Menu de Status (renderizado no body via Teleport) -->
    <Teleport to="body">
      <div v-if="showStatusMenu" @click="closeStatusMenu" class="status-menu-backdrop">
        <div @click.stop class="status-menu">
          <div class="status-menu-header">
            <span class="text-xs font-weight-bold">Selecione o Status</span>
            <button @click="closeStatusMenu" class="btn-close-menu">×</button>
          </div>
          <div
            v-for="option in statusOptions"
            :key="option.value"
            @click="selectStatusFromMenu(option.value)"
            class="status-option"
            :style="{ background: option.color, color: option.textColor }"
          >
            <span class="status-icon">{{ getIconForStatus(option.value) }}</span>
            <span class="status-label">{{ option.label }}</span>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- Modal de Observação -->
    <Teleport to="body">
      <div v-if="showNoteModal" class="note-modal-backdrop" @click="closeNoteModal">
        <div class="note-modal" @click.stop>
          <div class="note-modal-header">
            <div>
              <i class="fas fa-sticky-note me-2"></i>
              <strong>Observação</strong>
            </div>
            <span class="note-modal-date">{{ formatNoteDateLabel(currentNoteDate) }}</span>
            <button class="btn-close-note" @click="closeNoteModal">&times;</button>
          </div>
          <div class="note-modal-body">
            <textarea
              v-model="currentNoteText"
              class="note-textarea"
              placeholder="Escreva sua observação aqui..."
              rows="5"
              maxlength="500"
            ></textarea>
            <div class="note-char-count">{{ (currentNoteText || '').length }}/500</div>
          </div>
          <div class="note-modal-footer">
            <button class="btn btn-sm btn-outline-secondary" @click="closeNoteModal">Cancelar</button>
            <button class="btn btn-sm btn-primary" @click="saveNote" :disabled="savingNote">
              <i v-if="savingNote" class="fas fa-spinner fa-spin me-1"></i>
              <i v-else class="fas fa-save me-1"></i>
              {{ savingNote ? 'Salvando...' : 'Salvar' }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import planosTreinoRepository from '@/services/api/planosTreinoRepository'
import kpiRepository from '@/services/api/kpiRepository'
import alunoRepository from '@/services/api/alunoRepository'

export default {
  name: 'AgendaTreinos',
  data() {
    return {
      students: [],
      viewMode: 'week',
      currentWeek: 0,
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      showStatistics: null,
      statusData: {},
      studentKpiData: {}, // Armazena dados de KPI por aluno
      daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      loading: false,
      showStatusMenu: false, // Controla se o menu está aberto
      currentMenuStudentId: null, // ID do aluno do menu atual
      currentMenuDate: null, // Data do menu atual
      statusOptions: [
        { value: 'none', label: 'Sem Status', color: '#ffffff', textColor: '#666' },
        { value: 'scheduled', label: 'Treino Previsto', color: '#a855f7', textColor: '#fff' },
        { value: 'executed', label: 'Treino Executado', color: '#28a745', textColor: '#fff' },
        { value: 'incomplete', label: 'Treino Incompleto', color: '#ffeb3b', textColor: '#333' },
        { value: 'not_executed', label: 'Não Executado', color: '#dc3545', textColor: '#fff' },
        { value: 'excess', label: 'Treino Excedente', color: '#2196f3', textColor: '#fff' },
        { value: 'vacation', label: 'Férias', color: '#ff9800', textColor: '#fff' }
      ],
      notesData: {}, // Armazena observações por chave (studentId-year-month-date)
      showNoteModal: false, // Controla se o modal de observação está aberto
      currentNoteKey: null, // Chave do dia atual para a nota
      currentNoteDate: null, // Data atual para a nota
      currentNoteText: '', // Texto da nota sendo editada
      savingNote: false, // Flag de salvamento
      showPlanCalendars: true, // Controla visibilidade dos calendários do plano
      showMonthCalendar: true, // Controla visibilidade do calendário do mês
      showMonthSummary: true, // Controla visibilidade do resumo do mês
      showResumoGeral: true, // Controla visibilidade do Resumo Geral
      // Exercícios do dia
      calendarMonth: new Date().getMonth(), // Mês do calendário visual (0-11)
      calendarYear: new Date().getFullYear() // Ano do calendário visual
    }
  },
  computed: {
    ...mapGetters(['StudentManager', 'TrainingPlanManager']),
    selectedStudentId() {
      return this.StudentManager
    },
    selectedTrainingPlanId() {
      return this.TrainingPlanManager
    },
    hasSelectedStudent() {
      return !!this.StudentManager
    },
    weekDates() {
      return this.getWeekDates(this.currentWeek)
    },
    weekStart() {
      return this.formatDate(this.weekDates[0])
    },
    weekEnd() {
      return this.formatDate(this.weekDates[6])
    },
    currentMonthName() {
      const date = new Date(this.currentYear, this.currentMonth)
      return date.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })
    },
    displayDays() {
      if (this.viewMode === 'week') {
        return this.weekDates.map((date) => ({
          label: this.daysOfWeek[date.getDay()],
          date: date
        }))
      } else if (this.viewMode === 'month') {
        return this.getMonthDays()
      } else {
        return this.getPlanDays()
      }
    },
    // Computed para gerar dados do calendário do mês atual
    monthCalendarData() {
      const nomeMeses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]

      if (this.students.length === 0) {
        return {
          monthName: nomeMeses[this.calendarMonth],
          year: this.calendarYear,
          weeks: [],
          previstos: 0,
          executados: 0,
          naoExecutados: 0
        }
      }

      const student = this.students[0]
      const ano = this.calendarYear
      const mes = this.calendarMonth

      // Calcular período do plano do aluno
      const inicioPlano = student.startDate ? new Date(student.startDate) : null
      const fimPlano = student.endDate ? new Date(student.endDate) : null

      // Mapear dias de treino para números (0 = domingo, 1 = segunda, etc)
      const dayMapping = { 'Dom': 0, 'Seg': 1, 'Ter': 2, 'Qua': 3, 'Qui': 4, 'Sex': 5, 'Sáb': 6 }
      const diasDeTreino = (student.trainDays || []).map(d => dayMapping[d]).filter(d => d !== undefined)

      const primeiroDia = new Date(ano, mes, 1)
      const ultimoDia = new Date(ano, mes + 1, 0)
      const diasNoMes = ultimoDia.getDate()

      // A grade e exibida de segunda a domingo. getDay() devolve 0 para domingo,
      // entao o deslocamento inicial precisa ser convertido: seg=0 ... dom=6.
      // Antes a grade era montada de domingo a sabado e cada linha era girada
      // depois, o que colocava na coluna de domingo o domingo que ABRIA a
      // semana em vez do que a fecha (a linha de 17 a 22 mostrava 16).
      const offsetInicial = (primeiroDia.getDay() + 6) % 7

      const semanas = []
      let semanaAtual = []
      let previstos = 0
      let executados = 0
      let naoExecutados = 0

      // Adiciona dias vazios no início
      for (let i = 0; i < offsetInicial; i++) {
        semanaAtual.push({ vazio: true })
      }

      // Adiciona os dias do mês
      const hoje = new Date()
      hoje.setHours(0, 0, 0, 0) // Zerar horas para comparação de datas

      for (let dia = 1; dia <= diasNoMes; dia++) {
        const dataAtual = new Date(ano, mes, dia)
        const dataStr = this.formatDateISO(dataAtual)

        // Verificar se está dentro do período do plano
        const dentroPeriodo = inicioPlano && fimPlano && dataAtual >= inicioPlano && dataAtual <= fimPlano
        const ehDiaTreino = diasDeTreino.includes(dataAtual.getDay())
        const diaPassou = dataAtual < hoje // O dia já passou?

        // Verificar status real do dia
        const status = this.getStatus(student.id, dataAtual)
        const executado = status === 'executed'
        const incompleto = status === 'incomplete'
        const ferias = status === 'vacation'
        const excedente = status === 'excess'

        // Não executado: só se o dia já passou E (status é not_executed OU é dia de treino sem status definido)
        const naoExecutado = diaPassou && dentroPeriodo && ehDiaTreino &&
          (status === 'not_executed' || (status === 'none' && !executado && !incompleto && !ferias && !excedente))

        // Previsto: é dia de treino, dentro do período, não executou ainda, e o dia ainda não passou
        const previsto = dentroPeriodo && ehDiaTreino && !executado && !incompleto && !ferias && !excedente && !naoExecutado && !diaPassou

        if (previsto) previstos++
        if (executado || incompleto) executados++
        if (naoExecutado) naoExecutados++

        semanaAtual.push({
          numero: dia,
          previsto: previsto,
          executado: executado,
          naoExecutado: naoExecutado,
          incompleto: incompleto,
          ferias: ferias,
          excedente: excedente,
          foraPeriodo: !dentroPeriodo,
          vazio: false,
          data: dataStr
        })

        if (semanaAtual.length === 7) {
          semanas.push(semanaAtual)
          semanaAtual = []
        }
      }

      // Completa a última semana
      while (semanaAtual.length > 0 && semanaAtual.length < 7) {
        semanaAtual.push({ vazio: true })
      }
      if (semanaAtual.length > 0) {
        semanas.push(semanaAtual)
      }

      return {
        monthName: nomeMeses[mes],
        year: ano,
        weeks: semanas,
        previstos: previstos,
        executados: executados,
        naoExecutados: naoExecutados
      }
    },
    // Computed para reordenar o calendário para começar na segunda-feira
    monthCalendarDataReordered() {
      const data = this.monthCalendarData
      if (!data.weeks || data.weeks.length === 0) {
        return data
      }

      // monthCalendarData ja monta as semanas de segunda a domingo.
      // A rotacao que existia aqui movia o domingo da propria linha para o fim
      // dela, adiantando a coluna de domingo em uma semana inteira.
      return data
    },
    // Computed para gerar dados dos calendários do plano
    planCalendarData() {
      if (this.students.length === 0) {
        return { months: [], resumoPorMes: [], totalPrevistos: 0, totalExecutados: 0 }
      }

      // Pegar o primeiro aluno (ou o único se estiver filtrado)
      const student = this.students[0]
      if (!student || !student.startDate || !student.endDate) {
        return { months: [], resumoPorMes: [], totalPrevistos: 0, totalExecutados: 0 }
      }

      const inicio = new Date(student.startDate)
      const fim = new Date(student.endDate)
      const nomeMeses = [
        'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
        'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
      ]
      const nomeMesesCapitalizados = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]

      // Mapear dias de treino para números (0 = domingo, 1 = segunda, etc)
      const dayMapping = { 'Dom': 0, 'Seg': 1, 'Ter': 2, 'Qua': 3, 'Qui': 4, 'Sex': 5, 'Sáb': 6 }
      const diasDeTreino = (student.trainDays || []).map(d => dayMapping[d]).filter(d => d !== undefined)

      const calendarios = []
      const resumoPorMes = []
      let totalPrevistos = 0
      let totalExecutados = 0

      // Iterar por cada mês no período
      const current = new Date(inicio.getFullYear(), inicio.getMonth(), 1)
      const fimMes = new Date(fim.getFullYear(), fim.getMonth(), 1)

      while (current <= fimMes) {
        const ano = current.getFullYear()
        const mes = current.getMonth()
        const primeiroDia = new Date(ano, mes, 1)
        const ultimoDia = new Date(ano, mes + 1, 0)
        const diasNoMes = ultimoDia.getDate()
        const diaDaSemanaInicio = primeiroDia.getDay()

        const semanas = []
        let semanaAtual = []
        let previstosNoMes = 0
        let executadosNoMes = 0

        // Adiciona dias vazios no início
        for (let i = 0; i < diaDaSemanaInicio; i++) {
          semanaAtual.push({ vazio: true })
        }

        // Adiciona os dias do mês
        const hoje = new Date()
        hoje.setHours(0, 0, 0, 0) // Zerar horas para comparação de datas

        for (let dia = 1; dia <= diasNoMes; dia++) {
          const dataAtual = new Date(ano, mes, dia)
          const dataStr = this.formatDateISO(dataAtual)

          const dentroPeriodo = dataAtual >= inicio && dataAtual <= fim
          const ehDiaTreino = diasDeTreino.includes(dataAtual.getDay())
          const diaPassou = dataAtual < hoje // O dia já passou?

          // Verificar status real do dia
          const status = this.getStatus(student.id, dataAtual)
          const executado = status === 'executed'
          const incompleto = status === 'incomplete'
          const ferias = status === 'vacation'
          const excedente = status === 'excess'

          // Não executado: só se o dia já passou E (status é not_executed OU é dia de treino sem status definido)
          const naoExecutado = diaPassou && dentroPeriodo && ehDiaTreino &&
            (status === 'not_executed' || (status === 'none' && !executado && !incompleto && !ferias && !excedente))

          // Previsto: é dia de treino, dentro do período, não executou ainda, e o dia ainda não passou
          const previsto = dentroPeriodo && ehDiaTreino && !executado && !incompleto && !ferias && !excedente && !naoExecutado && !diaPassou

          if (previsto) previstosNoMes++
          if (executado || incompleto) executadosNoMes++

          semanaAtual.push({
            numero: dia,
            previsto: previsto,
            executado: executado,
            naoExecutado: naoExecutado,
            incompleto: incompleto,
            ferias: ferias,
            excedente: excedente,
            foraPeriodo: !dentroPeriodo,
            vazio: false,
            data: dataStr
          })

          if (semanaAtual.length === 7) {
            semanas.push(semanaAtual)
            semanaAtual = []
          }
        }

        // Completa a última semana
        while (semanaAtual.length > 0 && semanaAtual.length < 7) {
          semanaAtual.push({ vazio: true })
        }
        if (semanaAtual.length > 0) {
          semanas.push(semanaAtual)
        }

        calendarios.push({
          nome: nomeMeses[mes],
          ano: ano,
          semanas: semanas
        })

        resumoPorMes.push({
          nome: `${nomeMesesCapitalizados[mes]} De ${ano}`,
          previstos: previstosNoMes,
          executados: executadosNoMes
        })

        totalPrevistos += previstosNoMes
        totalExecutados += executadosNoMes

        current.setMonth(current.getMonth() + 1)
      }

      return {
        months: calendarios,
        resumoPorMes: resumoPorMes,
        totalPrevistos: totalPrevistos,
        totalExecutados: totalExecutados
      }
    }
  },
  watch: {
    // Quando um aluno é selecionado e o viewMode é 'week', mudar para 'month'
    hasSelectedStudent(newVal) {
      if (newVal && this.viewMode === 'week') {
        this.viewMode = 'month'
      }
    }
  },
  mounted() {
    // NÃO limpar a seleção do aluno - queremos manter para filtrar
    this.loadStudents()
    // Limpar localStorage antigo para evitar conflitos
    localStorage.removeItem('agendaTreinos_status')
    // Se já tem aluno selecionado e está em modo semana, mudar para mês
    if (this.hasSelectedStudent && this.viewMode === 'week') {
      this.viewMode = 'month'
    }
  },
  methods: {
    async loadStudents() {
      try {
        this.loading = true

        // Verificar se há um aluno selecionado no header
        // Converter para número para comparação correta
        const selectedStudentId = this.selectedStudentId ? parseInt(this.selectedStudentId) : null
        const selectedPlanId = this.selectedTrainingPlanId ? parseInt(this.selectedTrainingPlanId) : null

        console.log('[Agenda] Aluno selecionado:', selectedStudentId, 'Plano:', selectedPlanId)

        const planosResponse = await planosTreinoRepository.PlanosTreinoGet()

        if (!planosResponse.data.success) {
          throw new Error('Erro ao buscar planos de treino')
        }

        let planos = planosResponse.data.data

        // Garantir que planos seja um array
        if (!Array.isArray(planos)) {
          planos = [planos]
        }

        console.log('[Agenda] Planos recebidos:', planos.length)

        const dayMapping = {
          'dom': 'Dom',
          'seg': 'Seg',
          'ter': 'Ter',
          'qua': 'Qua',
          'qui': 'Qui',
          'sex': 'Sex',
          'sab': 'Sáb'
        }

        const alunosMap = new Map()

        // Se há um aluno selecionado no header, a API já filtra os planos dele
        // MAS a resposta não inclui o array 'students' - precisamos buscar os dados do aluno
        if (selectedStudentId) {
          console.log('[Agenda] Modo: aluno selecionado - buscando dados do aluno')
          console.log('[Agenda] Planos do aluno selecionado:', planos.length, planos)

          // Buscar dados do aluno selecionado
          try {
            const alunoResponse = await alunoRepository.AlunoGetById(selectedStudentId)
            console.log('[Agenda] Resposta AlunoGetById:', alunoResponse.data)

            if (alunoResponse.data.success && alunoResponse.data.data) {
              const aluno = alunoResponse.data.data
              console.log('[Agenda] Dados do aluno:', aluno)

              // Se não há planos, usar o plano selecionado no Vuex
              if (planos.length === 0 && selectedPlanId) {
                console.log('[Agenda] Nenhum plano retornado, usando plano selecionado:', selectedPlanId)

                // Parsear training_days
                let trainDays = []
                if (aluno.training_days) {
                  try {
                    const parsedDays = typeof aluno.training_days === 'string'
                      ? JSON.parse(aluno.training_days)
                      : aluno.training_days

                    trainDays = parsedDays
                      .map(day => dayMapping[day.toLowerCase()] || day)
                      .filter(Boolean)
                  } catch (e) {
                    console.error(`Erro ao parsear training_days:`, e)
                  }
                }

                // Buscar dados do plano diretamente
                try {
                  const planoResponse = await planosTreinoRepository.PlanosTreinoGetById(selectedPlanId)
                  console.log('[Agenda] Dados do plano:', planoResponse.data)

                  if (planoResponse.data.success && planoResponse.data.data) {
                    const plano = planoResponse.data.data
                    alunosMap.set(aluno.id, {
                      id: aluno.id,
                      name: `${aluno.name || ''} ${aluno.surname || ''}`.trim(),
                      weeklyClasses: trainDays.length || 0,
                      trainDays: trainDays,
                      startDate: plano.initial_date || null,
                      endDate: plano.final_date || null,
                      email: aluno.email || '',
                      phone: aluno.phone || '',
                      trainingPlanId: plano.id
                    })
                  }
                } catch (planoError) {
                  console.error('[Agenda] Erro ao buscar plano:', planoError)
                }
              } else {
                // Processar cada plano do aluno
                planos.forEach(plano => {
                  const planoId = parseInt(plano.id)

                  // Se há um plano específico selecionado, usar apenas esse
                  if (selectedPlanId && planoId !== selectedPlanId) {
                    return
                  }

                  // Parsear training_days
                  let trainDays = []
                  if (aluno.training_days) {
                    try {
                      const parsedDays = typeof aluno.training_days === 'string'
                        ? JSON.parse(aluno.training_days)
                        : aluno.training_days

                      trainDays = parsedDays
                        .map(day => dayMapping[day.toLowerCase()] || day)
                        .filter(Boolean)
                    } catch (e) {
                      console.error(`Erro ao parsear training_days:`, e)
                    }
                  }

                  // Verificar se este plano é mais recente que o existente
                  const existingStudent = alunosMap.get(aluno.id)
                  const currentPlanStart = plano.initial_date ? new Date(plano.initial_date) : null
                  const existingPlanStart = existingStudent?.startDate ? new Date(existingStudent.startDate) : null

                  if (selectedPlanId || !existingStudent || (currentPlanStart && existingPlanStart && currentPlanStart > existingPlanStart)) {
                    alunosMap.set(aluno.id, {
                      id: aluno.id,
                      name: `${aluno.name || ''} ${aluno.surname || ''}`.trim(),
                      weeklyClasses: trainDays.length || 0,
                      trainDays: trainDays,
                      startDate: plano.initial_date || null,
                      endDate: plano.final_date || null,
                      email: aluno.email || '',
                      phone: aluno.phone || '',
                      trainingPlanId: plano.id
                    })
                  }
                })
              }
            }
          } catch (error) {
            console.error('[Agenda] Erro ao buscar dados do aluno:', error)
          }
        } else {
          // Modo normal: sem aluno selecionado - processar todos os planos com students
          console.log('[Agenda] Modo: todos os alunos')

          planos.forEach(plano => {
            const planoId = parseInt(plano.id)

            // Se há um plano selecionado, filtrar apenas por esse plano
            if (selectedPlanId && planoId !== selectedPlanId) {
              return
            }

            if (plano.students && plano.students.length > 0) {
              plano.students.forEach(aluno => {
                // Processa cada plano do aluno
                let trainDays = []
                if (aluno.training_days) {
                  try {
                    const parsedDays = typeof aluno.training_days === 'string'
                      ? JSON.parse(aluno.training_days)
                      : aluno.training_days

                    trainDays = parsedDays
                      .map(day => dayMapping[day.toLowerCase()] || day)
                      .filter(Boolean)
                  } catch (e) {
                    console.error(`Erro ao parsear training_days do aluno ${aluno.name}:`, e)
                  }
                }

                // Verifica se já existe e se o plano atual é mais recente
                const existingStudent = alunosMap.get(aluno.id)
                const currentPlanStart = plano.initial_date ? new Date(plano.initial_date) : null
                const existingPlanStart = existingStudent?.startDate ? new Date(existingStudent.startDate) : null

                if (!existingStudent || (currentPlanStart && existingPlanStart && currentPlanStart > existingPlanStart)) {
                  alunosMap.set(aluno.id, {
                    id: aluno.id,
                    name: `${aluno.name || ''} ${aluno.surname || ''}`.trim(),
                    weeklyClasses: trainDays.length || 0,
                    trainDays: trainDays,
                    startDate: plano.initial_date || null,
                    endDate: plano.final_date || null,
                    email: aluno.email || '',
                    phone: aluno.phone || '',
                    trainingPlanId: plano.id
                  })
                }
              })
            }
          })
        }

        this.students = Array.from(alunosMap.values())
        console.log('[Agenda] Alunos carregados:', this.students.length)

        // Se há apenas 1 aluno (selecionado no header), abrir estatísticas automaticamente
        if (this.students.length === 1 && selectedStudentId) {
          const student = this.students[0]
          this.showStatistics = student.id
          // Carregar dados de KPI automaticamente
          await this.loadStudentKpiData(student.id)
        }

        // Preencher automaticamente os treinos previstos
        this.fillScheduledTrainings()

      } catch (error) {
        console.error('Erro ao carregar alunos e planos:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível carregar os dados dos alunos e planos de treino.'
        })
      } finally {
        this.loading = false
      }
    },
    navigateWeek(offset) {
      if (this.viewMode === 'week') {
        this.currentWeek += offset
      } else if (this.viewMode === 'month') {
        this.currentMonth += offset
        if (this.currentMonth > 11) {
          this.currentMonth = 0
          this.currentYear++
        } else if (this.currentMonth < 0) {
          this.currentMonth = 11
          this.currentYear--
        }
        // Sincronizar o calendário visual com a navegação
        this.calendarMonth = this.currentMonth
        this.calendarYear = this.currentYear
      }
    },
    navigateCalendarMonth(offset) {
      this.calendarMonth += offset
      if (this.calendarMonth > 11) {
        this.calendarMonth = 0
        this.calendarYear++
      } else if (this.calendarMonth < 0) {
        this.calendarMonth = 11
        this.calendarYear--
      }
      // Sincronizar também a navegação principal da tabela
      this.currentMonth = this.calendarMonth
      this.currentYear = this.calendarYear
    },
    goToToday() {
      const today = new Date()
      this.currentWeek = 0
      this.currentMonth = today.getMonth()
      this.currentYear = today.getFullYear()
      this.calendarMonth = today.getMonth()
      this.calendarYear = today.getFullYear()
    },
    getWeekDates(weekOffset) {
      const today = new Date()
      const currentDay = today.getDay()
      const diff = today.getDate() - currentDay + weekOffset * 7
      const sunday = new Date(today.setDate(diff))

      return Array.from({ length: 7 }, (_, i) => {
        const date = new Date(sunday)
        date.setDate(sunday.getDate() + i)
        return date
      })
    },
    getMonthDays() {
      const days = []
      const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate()

      for (let i = 1; i <= daysInMonth; i++) {
        const date = new Date(this.currentYear, this.currentMonth, i)
        days.push({
          label: `${i}/${this.currentMonth + 1}`,
          date: date
        })
      }

      return days
    },
    getPlanDays() {
      const days = []
      if (this.students.length > 0) {
        const student = this.students[0]
        if (student.startDate && student.endDate) {
          const start = new Date(student.startDate)
          const end = new Date(student.endDate)
          const current = new Date(start)

          while (current <= end) {
            days.push({
              label: this.formatDate(current),
              date: new Date(current)
            })
            current.setDate(current.getDate() + 1)
          }
        }
      }
      return days
    },
    async fillScheduledTrainings() {
      // Carregar os treinos reais do backend para cada aluno
      // Os dias de treino vêm do current-plan com status: executed, incomplete, not_executed
      for (const student of this.students) {
        await this.loadRealTrainingsFromBackend(student.id, student.trainingPlanId)
      }
    },
    async loadRealTrainingsFromBackend(studentId, trainingPlanId) {
      try {
        // Converter para base64
        const studentIdBase64 = btoa(studentId)
        const trainingPlanIdBase64 = btoa(trainingPlanId)

        const headers = {
          'student-manager': studentIdBase64,
          'training-plan-manager': trainingPlanIdBase64
        }

        // Buscar os treinos reais do aluno
        const response = await planosTreinoRepository.DiasDeTreinoPlanoAtualGet({ headers })

        if (response.data.success) {
          const trainings = response.data.data

          console.log(`[Agenda] Treinos recebidos do backend para aluno ${studentId}:`, trainings)

          // Percorrer os treinos e adicionar ao statusData
          trainings.forEach(training => {
            // Parsear a data corretamente (YYYY-MM-DD) para evitar problemas de timezone
            const [year, month, day] = training.training_date.split('-').map(Number)
            const date = new Date(year, month - 1, day) // month é 0-indexed
            const key = this.getDateKey(studentId, date)

            console.log(`[Agenda] Treino: ${training.training_date} -> key: ${key} -> status: ${training.status}`)

            // Mapear o status do backend para o status da agenda
            this.statusData[key] = training.status

            // Carregar observação se existir
            if (training.observation) {
              this.notesData[key] = training.observation
            }
          })

          // Forçar reatividade
          this.statusData = { ...this.statusData }
          this.notesData = { ...this.notesData }
        }
      } catch (error) {
        console.error('Erro ao carregar treinos reais do backend:', error)
      }
    },
    async saveStatusToBackend(studentId, date, status) {
      const student = this.students.find(s => s.id === studentId)
      if (!student || !student.trainingPlanId) {
        throw new Error('Aluno ou plano de treino não encontrado')
      }

      // Converter para base64
      const studentIdBase64 = btoa(studentId)
      const trainingPlanIdBase64 = btoa(student.trainingPlanId)

      const headers = {
        'student-manager': studentIdBase64,
        'training-plan-manager': trainingPlanIdBase64
      }

      // Formatar a data no formato YYYY-MM-DD
      const trainingDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`

      console.log(`[Agenda] Salvando status "${status}" para data ${trainingDate}`)

      // Para executed e not_executed, atualizamos os exercícios (campo realized)
      if (status === 'executed' || status === 'not_executed') {
        // Buscar os exercícios do dia
        console.log('[Agenda] Buscando exercícios do dia...')
        try {
          const exercisesResponse = await planosTreinoRepository.TreinoPorDiaGet(trainingDate, { headers })

          console.log('[Agenda] Resposta exercícios:', exercisesResponse.data)

          // Só atualizar exercícios se existirem (pode ser dia só de cardio)
          if (exercisesResponse.data.success && exercisesResponse.data.data && exercisesResponse.data.data.length > 0) {
            const exercises = exercisesResponse.data.data

            // Definir o valor de realized baseado no status
            const realizedValue = status === 'executed'

            // Atualizar todos os exercícios com o novo valor de realized
            const updatedExercises = exercises.map(exercise => ({
              ...exercise,
              realized: realizedValue
            }))

            console.log(`[Agenda] Atualizando ${updatedExercises.length} exercícios com realized=${realizedValue}`)

            // Enviar para o backend
            const updateResponse = await planosTreinoRepository.PlanoTreinoAtualizarExerciciosDiaPost(updatedExercises, { headers })
            console.log('[Agenda] Resposta update:', updateResponse.data)
          } else {
            console.log('[Agenda] Nenhum exercício de peso encontrado para esta data (pode ser só cardio)')
          }
        } catch (exerciseError) {
          console.warn('[Agenda] Erro ao buscar/atualizar exercícios (continuando para salvar status):', exerciseError)
        }
      }

      // Para todos os status (exceto none), salvar na tabela training_schedule_status
      // IMPORTANTE: Sempre salvar o status, independente de haver exercícios
      console.log(`[Agenda] Salvando status na tabela training_schedule_status...`)
      const statusResponse = await planosTreinoRepository.DiasDeTreinoStatusPut(trainingDate, status, { headers })
      console.log('[Agenda] Resposta status:', statusResponse.data)
    },
    // === EXERCÍCIOS DO DIA ===
    goToStudentArea(dateStr) {
      if (!this.students || this.students.length === 0) return
      const student = this.students[0]
      if (!student) return

      // Setar headers do aluno no localStorage para a área do aluno carregar corretamente
      window.localStorage.setItem('student-manager', btoa(student.id))
      if (student.trainingPlanId) {
        window.localStorage.setItem('training-plan-manager', btoa(student.trainingPlanId))
      }

      this.$router.push({ path: '/area-aluno', query: { date: dateStr } })
    },
    // === OBSERVAÇÕES / NOTAS ===
    getNoteForDate(dateStr) {
      if (!this.students || this.students.length === 0) return ''
      const student = this.students[0]
      const [year, month, day] = dateStr.split('-').map(Number)
      const date = new Date(year, month - 1, day)
      const key = this.getDateKey(student.id, date)
      return this.notesData[key] || ''
    },
    async openNoteModal(dateStr) {
      if (!this.students || this.students.length === 0) return
      const student = this.students[0]
      if (!student || !student.trainingPlanId) return
      const [year, month, day] = dateStr.split('-').map(Number)
      const date = new Date(year, month - 1, day)
      const key = this.getDateKey(student.id, date)
      this.currentNoteKey = key
      this.currentNoteDate = dateStr
      this.currentNoteText = this.notesData[key] || ''
      this.showNoteModal = true

      // Se não tem observação local, buscar dos exercícios (área do aluno)
      if (!this.currentNoteText) {
        try {
          const studentIdBase64 = btoa(student.id)
          const trainingPlanIdBase64 = btoa(student.trainingPlanId)
          const headers = {
            'student-manager': studentIdBase64,
            'training-plan-manager': trainingPlanIdBase64
          }
          const response = await planosTreinoRepository.TreinoPorDiaGet(dateStr, { headers })
          if (response.data.success && response.data.data && response.data.data.length > 0) {
            const firstObs = response.data.data[0].observation
            if (firstObs) {
              this.currentNoteText = firstObs
              this.notesData = { ...this.notesData, [key]: firstObs }
            }
          }
        } catch (e) {
          console.warn('[Agenda] Erro ao buscar observação dos exercícios:', e)
        }
      }
    },
    closeNoteModal() {
      this.showNoteModal = false
      this.currentNoteKey = null
      this.currentNoteDate = null
      this.currentNoteText = ''
    },
    async saveNote() {
      if (!this.currentNoteKey || !this.currentNoteDate) return
      if (!this.students || this.students.length === 0) return

      const student = this.students[0]
      if (!student || !student.trainingPlanId) return

      this.savingNote = true

      try {
        // Atualizar localmente
        this.notesData = { ...this.notesData, [this.currentNoteKey]: this.currentNoteText }

        // Preparar headers
        const studentIdBase64 = btoa(student.id)
        const trainingPlanIdBase64 = btoa(student.trainingPlanId)
        const headers = {
          'student-manager': studentIdBase64,
          'training-plan-manager': trainingPlanIdBase64
        }

        // 1) Salvar no status do dia (training_schedule_status)
        const [year, month, day] = this.currentNoteDate.split('-').map(Number)
        const date = new Date(year, month - 1, day)
        const currentStatus = this.getStatus(student.id, date) || 'none'
        const statusToSend = currentStatus === 'none' ? 'scheduled' : currentStatus

        await planosTreinoRepository.DiasDeTreinoStatusPut(
          this.currentNoteDate,
          statusToSend,
          { headers },
          this.currentNoteText || null
        )

        // 2) Salvar nos exercícios do dia (training_plan_exercises) — mesmo lugar que a área do aluno
        try {
          const exercisesResponse = await planosTreinoRepository.TreinoPorDiaGet(this.currentNoteDate, { headers })
          if (exercisesResponse.data.success && exercisesResponse.data.data && exercisesResponse.data.data.length > 0) {
            const exercises = exercisesResponse.data.data
            const updatedExercises = exercises.map(exercise => ({
              ...exercise,
              observation: this.currentNoteText || null
            }))
            await planosTreinoRepository.PlanoTreinoAtualizarExerciciosDiaPost(updatedExercises, { headers })
            console.log('[Agenda] Observação salva nos exercícios também')
          }
        } catch (exError) {
          console.warn('[Agenda] Não foi possível salvar observação nos exercícios:', exError)
        }

        console.log('[Agenda] Observação salva com sucesso')
        this.closeNoteModal()
      } catch (error) {
        console.error('[Agenda] Erro ao salvar observação:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível salvar a observação. Tente novamente.'
        })
      } finally {
        this.savingNote = false
      }
    },
    formatNoteDateLabel(dateStr) {
      if (!dateStr) return ''
      const [year, month, day] = dateStr.split('-').map(Number)
      const date = new Date(year, month - 1, day)
      const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }
      return date.toLocaleDateString('pt-BR', options)
    },
    async toggleStatistics(studentId) {
      if (this.showStatistics === studentId) {
        this.showStatistics = null
      } else {
        this.showStatistics = studentId
        // Buscar dados de KPI do aluno se ainda não foram carregados
        if (!this.studentKpiData[studentId]) {
          await this.loadStudentKpiData(studentId)
        }
      }
    },
    async loadStudentKpiData(studentId) {
      try {
        const student = this.students.find(s => s.id === studentId)
        if (!student || !student.trainingPlanId) {
          console.error('Aluno ou plano de treino não encontrado')
          return
        }

        // Converter para base64
        const studentIdBase64 = btoa(studentId)
        const trainingPlanIdBase64 = btoa(student.trainingPlanId)

        const headers = {
          'student-manager': studentIdBase64,
          'training-plan-manager': trainingPlanIdBase64
        }

        const response = await kpiRepository.TrainingResumeGet({ headers })

        if (response.data.success) {
          // Usar Object.assign ou spread para garantir reatividade
          this.studentKpiData = {
            ...this.studentKpiData,
            [studentId]: response.data.data
          }
        }
      } catch (error) {
        console.error('Erro ao buscar dados de KPI:', error)
      }
    },
    toggleStatusMenu(studentId, date) {
      // Permite abrir o menu para qualquer dia dentro do período do plano
      // O status pode ser salvo mesmo para dias sem exercícios agendados

      if (this.showStatusMenu && this.currentMenuStudentId === studentId &&
          this.currentMenuDate?.getTime() === date.getTime()) {
        this.showStatusMenu = false
        this.currentMenuStudentId = null
        this.currentMenuDate = null
      } else {
        this.showStatusMenu = true
        this.currentMenuStudentId = studentId
        this.currentMenuDate = date
      }
    },
    closeStatusMenu() {
      this.showStatusMenu = false
      this.currentMenuStudentId = null
      this.currentMenuDate = null
    },
    openCalendarStatusMenu(dateStr) {
      // Abre o menu de status para a data clicada no calendário
      if (!this.students || this.students.length === 0) {
        return
      }

      // Pegar o primeiro aluno (que é o selecionado)
      const student = this.students[0]
      if (!student) {
        return
      }

      // Converter a string de data para objeto Date
      const [year, month, day] = dateStr.split('-').map(Number)
      const date = new Date(year, month - 1, day)

      // Usar o mesmo método toggleStatusMenu
      this.toggleStatusMenu(student.id, date)
    },
    async selectStatusFromMenu(newStatus) {
      if (!this.currentMenuStudentId || !this.currentMenuDate) return

      // Guardar referências antes de fechar o menu
      const studentId = this.currentMenuStudentId
      const date = this.currentMenuDate
      const key = this.getDateKey(studentId, date)
      const oldStatus = this.statusData[key]

      console.log(`[Agenda] Alterando status: ${oldStatus} -> ${newStatus} para key: ${key}`)

      // Atualizar status localmente (forçando reatividade)
      this.statusData = { ...this.statusData, [key]: newStatus }

      // Fechar o menu primeiro para melhor UX
      this.closeStatusMenu()

      // Salvar no backend (incluindo 'none' para remover status)
      try {
        await this.saveStatusToBackend(studentId, date, newStatus)
        console.log('[Agenda] Status salvo com sucesso no backend')

        // Recarregar dados de KPI para atualizar o resumo
        if (this.showStatistics === studentId) {
          await this.loadStudentKpiData(studentId)
          console.log('[Agenda] KPI atualizado após mudança de status')
        }
      } catch (error) {
        // Se falhar, reverter para o status anterior
        console.error('Erro ao salvar, revertendo status:', error)
        this.statusData = { ...this.statusData, [key]: oldStatus }
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível salvar o status. Por favor, tente novamente.'
        })
      }
    },
    async selectStatus(studentId, date, newStatus) {
      const key = this.getDateKey(studentId, date)

      this.statusData[key] = newStatus

      // Salvar no backend
      await this.saveStatusToBackend(studentId, date, newStatus)

      // Fechar o menu
      this.closeStatusMenu()
    },
    getIconForStatus(status) {
      const icons = {
        none: '',
        scheduled: 'P',
        executed: '✓',
        incomplete: '◐',
        not_executed: '✗',
        excess: '+',
        vacation: '☀'
      }
      return icons[status] || ''
    },
    getDateKey(studentId, date) {
      return `${studentId}-${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
    },
    getStatus(studentId, date) {
      const key = this.getDateKey(studentId, date)
      // Retorna APENAS o status que veio do backend (current-plan)
      // Se não existe no statusData, significa que não tem treino nesse dia
      return this.statusData[key] || 'none'
    },
    getStatusClass(studentId, date) {
      const status = this.getStatus(studentId, date)
      const classes = {
        none: 'bg-white',
        scheduled: 'bg-status-scheduled',
        executed: 'bg-status-executed',
        incomplete: 'bg-status-incomplete',
        not_executed: 'bg-status-not-executed',
        excess: 'bg-status-excess',
        vacation: 'bg-status-vacation'
      }
      return classes[status] || 'bg-white'
    },
    getStatusIcon(studentId, date) {
      const status = this.getStatus(studentId, date)
      const icons = {
        none: '',
        scheduled: 'P',
        executed: '✓',
        incomplete: '◐',
        not_executed: '✗',
        excess: '+',
        vacation: '☀'
      }
      return icons[status] || ''
    },
    getStatusLabel(studentId, date) {
      const status = this.getStatus(studentId, date)
      const labels = {
        none: '',
        scheduled: 'Previsto',
        executed: 'Executado',
        incomplete: 'Incompleto',
        not_executed: 'Não Executado',
        excess: 'Excedente',
        vacation: 'Férias'
      }
      return labels[status] || ''
    },
    // ✅ Métodos para o select de status no calendário grande
    getStatusForDate(dateStr) {
      if (!dateStr || !this.students || this.students.length === 0) return 'none'
      const student = this.students[0]
      if (!student) return 'none'

      // Converter string de data para objeto Date
      const [year, month, day] = dateStr.split('-').map(Number)
      const date = new Date(year, month - 1, day)

      return this.getStatus(student.id, date)
    },
    getStatusSelectClass(dateStr) {
      const status = this.getStatusForDate(dateStr)
      const classes = {
        none: 'status-select-none',
        scheduled: 'status-select-scheduled',
        executed: 'status-select-executed',
        incomplete: 'status-select-incomplete',
        not_executed: 'status-select-not-executed',
        excess: 'status-select-excess',
        vacation: 'status-select-vacation'
      }
      return classes[status] || 'status-select-none'
    },
    async onStatusSelectChange(event, dateStr) {
      const newStatus = event.target.value
      if (!dateStr || !this.students || this.students.length === 0) return

      const student = this.students[0]
      if (!student) return

      // Converter string de data para objeto Date
      const [year, month, day] = dateStr.split('-').map(Number)
      const date = new Date(year, month - 1, day)

      const key = this.getDateKey(student.id, date)
      const oldStatus = this.statusData[key]

      console.log(`[Agenda] Alterando status via select: ${oldStatus} -> ${newStatus} para key: ${key}`)

      // Atualizar status localmente
      this.statusData = { ...this.statusData, [key]: newStatus }

      // Salvar no backend (incluindo 'none' para remover status)
      try {
        await this.saveStatusToBackend(student.id, date, newStatus)
        console.log('[Agenda] Status salvo com sucesso no backend')

        // Sempre recarregar dados de KPI para atualizar o resumo
        await this.loadStudentKpiData(student.id)
        console.log('[Agenda] KPI atualizado após mudança de status')
      } catch (error) {
        console.error('Erro ao salvar, revertendo status:', error)
        this.statusData = { ...this.statusData, [key]: oldStatus }
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível salvar o status. Por favor, tente novamente.'
        })
      }
    },
    getMonthStats(student) {
      const kpiData = this.studentKpiData[student.id]

      if (!kpiData) {
        return {
          scheduled: 0,
          contracted: 0,
          executed: 0,
          notExecuted: 0,
          incomplete: 0,
          excess: 0,
          calories: 0
        }
      }

      // Pegar estatísticas do mês atual
      const currentMonth = new Date().toISOString().slice(0, 7) // YYYY-MM

      // Verificar se detalhes_por_mes é objeto ou array vazio
      const detalhesPorMes = (Array.isArray(kpiData.detalhes_por_mes) && kpiData.detalhes_por_mes.length === 0)
        ? {}
        : kpiData.detalhes_por_mes || {}

      const monthData = detalhesPorMes[currentMonth] || {}

      return {
        scheduled: monthData.previstos || 0,
        contracted: monthData.contratados || 0,
        executed: monthData.executados || 0,
        notExecuted: monthData.nao_executados || 0,
        incomplete: monthData.incompletos || 0,
        excess: monthData.excedentes || 0,
        calories: 0 // TODO: Implementar cálculo de calorias por mês
      }
    },
    // Retorna o resumo por mês do KPI para a tabela do topo (usando dados do backend)
    getKpiResumoPorMes(student) {
      const kpiData = this.studentKpiData[student.id]
      if (!kpiData) {
        return []
      }

      // Verificar se detalhes_por_mes é objeto ou array vazio
      const detalhesPorMes = (Array.isArray(kpiData.detalhes_por_mes) && kpiData.detalhes_por_mes.length === 0)
        ? {}
        : kpiData.detalhes_por_mes || {}

      const nomeMesesCapitalizados = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]

      // Converter o objeto detalhes_por_mes em array ordenado
      const meses = Object.keys(detalhesPorMes).sort()
      return meses.map(mesKey => {
        const mesData = detalhesPorMes[mesKey]
        const [ano, mes] = mesKey.split('-')
        const mesIndex = parseInt(mes) - 1
        return {
          nome: `${nomeMesesCapitalizados[mesIndex]} De ${ano}`,
          previstos: mesData.previstos || 0,
          contratados: mesData.contratados || 0,
          executados: mesData.executados || 0,
          naoExecutados: mesData.nao_executados || 0,
          incompletos: mesData.incompletos || 0,
          excedentes: mesData.excedentes || 0
        }
      })
    },
    // Retorna os totais do resumo por mês (usando dados diretos do KPI para consistência)
    getKpiResumoPorMesTotais(student) {
      const kpiData = this.studentKpiData[student.id]
      if (!kpiData) {
        return {
          totalPrevistos: 0,
          totalContratados: 0,
          totalExecutados: 0,
          totalNaoExecutados: 0,
          totalIncompletos: 0,
          totalExcedentes: 0
        }
      }

      // Usar os mesmos campos que a tabela "Resumo do Plano" para garantir consistência
      return {
        totalPrevistos: kpiData.total_trainings || 0,
        totalContratados: kpiData.total_contratadas_plano || 0,
        totalExecutados: kpiData.total_trainings_executed || 0,
        totalNaoExecutados: kpiData.total_trainings_not_executed || 0,
        totalIncompletos: kpiData.total_trainings_incomplete || 0,
        totalExcedentes: kpiData.total_trainings_excedentes || 0
      }
    },
    getPlanStats(student) {
      const kpiData = this.studentKpiData[student.id]
      if (!kpiData) {
        return {
          scheduled: 0,
          contracted: 0,
          executed: 0,
          notExecuted: 0,
          incomplete: 0,
          excess: 0,
          calories: 0
        }
      }

      return {
        scheduled: kpiData.total_trainings || 0,
        contracted: kpiData.total_contratadas_plano || 0,
        executed: kpiData.total_trainings_executed || 0,
        notExecuted: kpiData.total_trainings_not_executed || 0,
        incomplete: kpiData.total_trainings_incomplete || 0,
        excess: kpiData.total_trainings_excedentes || 0,
        calories: 0 // TODO: Implementar cálculo de calorias do plano
      }
    },
    getYearStats(student) {
      const kpiData = this.studentKpiData[student.id]
      if (!kpiData || !kpiData.resumo_ano) {
        return {
          contracted: 0,
          executed: 0,
          notExecuted: 0,
          incomplete: 0,
          excess: 0,
          calories: 0,
          pseAverage: '-',
          psrAverage: '-'
        }
      }

      const yearData = kpiData.resumo_ano

      return {
        contracted: yearData.aulas_contratadas ?? kpiData.aulas_contratadas_ano ?? yearData.total_trainings ?? 0,
        executed: yearData.total_trainings_executed || 0,
        notExecuted: yearData.total_trainings_not_executed || 0,
        incomplete: yearData.total_trainings_incomplete || 0,
        excess: yearData.total_trainings_excedentes || 0,
        calories: yearData.gasto_calorico || 0,
        pseAverage: (yearData.pse_medio !== null && yearData.pse_medio !== undefined) ? yearData.pse_medio.toFixed(2) : '-',
        psrAverage: (yearData.psr_medio !== null && yearData.psr_medio !== undefined) ? yearData.psr_medio.toFixed(2) : '-'
      }
    },
    getTotalStats(student) {
      const kpiData = this.studentKpiData[student.id]
      if (!kpiData || !kpiData.resumo_total) {
        return {
          contracted: 0,
          executed: 0,
          notExecuted: 0,
          incomplete: 0,
          excess: 0,
          calories: 0,
          pseAverage: '-',
          psrAverage: '-'
        }
      }

      const totalData = kpiData.resumo_total

      return {
        contracted: totalData.aulas_contratadas ?? kpiData.aulas_contratadas_total ?? totalData.total_trainings ?? 0,
        executed: totalData.total_trainings_executed || 0,
        notExecuted: totalData.total_trainings_not_executed || 0,
        incomplete: totalData.total_trainings_incomplete || 0,
        excess: totalData.total_trainings_excedentes || 0,
        calories: totalData.gasto_calorico || 0,
        pseAverage: (totalData.pse_medio !== null && totalData.pse_medio !== undefined) ? totalData.pse_medio.toFixed(2) : '-',
        psrAverage: (totalData.psr_medio !== null && totalData.psr_medio !== undefined) ? totalData.psr_medio.toFixed(2) : '-'
      }
    },
    sendReport(student) {
      const report = this.generateReport(student)
      const subject = `Relatório de Treinos - ${student.name}`
      const body = encodeURIComponent(report)

      if (student.email) {
        window.open(`mailto:${student.email}?subject=${encodeURIComponent(subject)}&body=${body}`)
      } else {
        navigator.clipboard.writeText(report).then(() => {
          this.$swal({
            icon: 'success',
            title: 'Copiado!',
            text: 'Relatório copiado para a área de transferência',
            timer: 2000,
            showConfirmButton: false
          })
        })
      }
    },
    generateReport(student) {
      return `RELATÓRIO DE TREINOS - ${student.name}\n\nPERÍODO: ${this.formatDateBR(student.startDate)} - ${this.formatDateBR(student.endDate)}\n\nRESUMO DO MÊS:\n...`
    },
    saveStatusToLocalStorage() {
      try {
        localStorage.setItem('agendaTreinos_status', JSON.stringify(this.statusData))
      } catch (e) {
        console.error('Erro ao salvar no localStorage:', e)
      }
    },
    loadStatusFromLocalStorage() {
      try {
        const saved = localStorage.getItem('agendaTreinos_status')
        if (saved) {
          this.statusData = JSON.parse(saved)
        }
      } catch (e) {
        console.error('Erro ao carregar do localStorage:', e)
      }
    },
    formatDate(date) {
      return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}`
    },
    formatDateShort(date) {
      return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}`
    },
    formatDateBR(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString + 'T00:00:00')
      return date.toLocaleDateString('pt-BR')
    },
    formatDateISO(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    isToday(date) {
      return new Date().toDateString() === date.toDateString()
    },
    // Métodos para os calendários do plano
    getDiaClass(dia) {
      if (dia.vazio) return 'dia-plano-vazio'
      if (dia.foraPeriodo) return 'dia-plano-fora'
      if (dia.executado) return 'dia-plano-executado'
      if (dia.incompleto) return 'dia-plano-incompleto'
      if (dia.ferias) return 'dia-plano-ferias'
      if (dia.excedente) return 'dia-plano-excedente'
      if (dia.naoExecutado) return 'dia-plano-nao-executado'
      if (dia.previsto) return 'dia-plano-previsto'
      return 'dia-plano-normal'
    },
    getDiaTooltip(dia) {
      if (dia.vazio || dia.foraPeriodo) return ''
      if (dia.executado) return 'Executado'
      if (dia.incompleto) return 'Incompleto'
      if (dia.ferias) return 'Férias'
      if (dia.excedente) return 'Excedente'
      if (dia.naoExecutado) return 'Não Executado'
      if (dia.previsto) return 'Previsto'
      return ''
    },
    getDiaClassGrande(dia) {
      if (dia.vazio) return 'dia-vazio'
      if (dia.foraPeriodo) return 'dia-fora-periodo'
      if (dia.executado) return 'dia-executado'
      if (dia.incompleto) return 'dia-incompleto'
      if (dia.ferias) return 'dia-ferias'
      if (dia.excedente) return 'dia-excedente'
      if (dia.naoExecutado) return 'dia-nao-executado'
      if (dia.previsto) return 'dia-previsto'
      return 'dia-normal'
    }
  }
}
</script>

<style scoped>
/* Coluna fixa de alunos */
.sticky-col {
  position: sticky;
  left: 0;
  z-index: 2;
  min-width: 200px;
  max-width: 200px;
}

.sticky-header {
  z-index: 3;
  background: linear-gradient(to right, #4f46e5, #7c3aed) !important;
}

.table-responsive {
  overflow-x: auto;
}

.cursor-pointer {
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.cursor-pointer:hover {
  opacity: 0.85;
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.cursor-pointer:active {
  transform: scale(0.98);
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}

.table-sm td, .table-sm th {
  padding: 0.3rem !important;
}

.btn-group .btn {
  font-size: 0.85rem;
}

/* Cores mais fortes para melhor visibilidade */
.text-success {
  color: #0d8c00 !important;
  font-weight: 700 !important;
}

.text-warning {
  color: #d48b00 !important;
  font-weight: 700 !important;
}

.text-danger {
  color: #dc3545 !important;
  font-weight: 700 !important;
}

/* Status colors - padronizadas com o aplicativo mobile */
.bg-status-scheduled {
  background-color: #a855f7 !important;
}
.bg-status-executed {
  background-color: #28a745 !important;
}
.bg-status-incomplete {
  background-color: #ffeb3b !important;
}
.bg-status-not-executed {
  background-color: #dc3545 !important;
}
.bg-status-excess {
  background-color: #2196f3 !important;
}
.bg-status-vacation {
  background-color: #ff9800 !important;
}

/* Menu de Seleção de Status */
.status-menu-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-menu {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  z-index: 10000;
  min-width: 250px;
  max-height: 90vh;
  overflow-y: auto;
}

.status-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-close-menu {
  background: transparent;
  border: none;
  color: white;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-close-menu:hover {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.status-option {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.status-option:last-child {
  border-bottom: none;
}

.status-option:hover {
  filter: brightness(1.1);
  transform: translateX(4px);
}

.status-icon {
  font-size: 18px;
  font-weight: bold;
  margin-right: 10px;
  min-width: 24px;
  text-align: center;
}

.status-label {
  font-size: 13px;
  font-weight: 600;
}

/* Overlay para fechar o menu ao clicar fora */
.status-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

/* ========== CALENDÁRIOS DO PLANO ========== */
.calendarios-plano-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 30px;
  border: 1px solid #e9ecef;
}

.calendario-meses-wrapper {
  gap: 30px;
}

.calendario-plano-mes {
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  min-width: 190px;
  max-width: 210px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  border: 1px solid #e9ecef;
}

.resumo-mes-container {
  min-width: 450px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.calendario-plano-header {
  text-align: left;
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 12px;
  color: #e91e63;
  text-transform: capitalize;
}

.calendario-plano-dias-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-size: 0.7rem;
  color: #999;
  margin-bottom: 8px;
  font-weight: 500;
}

.calendario-plano-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 3px;
  text-align: center;
  font-size: 0.75rem;
}

.calendario-plano-grid span {
  padding: 4px 2px;
  border-radius: 4px;
  color: #666;
  cursor: default;
  min-width: 22px;
  min-height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dia-plano-vazio {
  color: transparent !important;
  background: transparent !important;
}

.dia-plano-normal {
  color: #999;
}

.dia-plano-fora {
  color: #ccc !important;
}

.dia-plano-previsto {
  background: #c084fc !important;
  color: #fff !important;
  font-weight: 600;
}

.dia-plano-executado {
  background: #34d399 !important;
  color: #fff !important;
  font-weight: 600;
}

.dia-plano-nao-executado {
  background: #f87171 !important;
  color: #fff !important;
  font-weight: 600;
}

.dia-plano-incompleto {
  background: #ffeb3b !important;
  color: #333 !important;
  font-weight: 600;
}

.dia-plano-ferias {
  background: #ff9800 !important;
  color: #fff !important;
  font-weight: 600;
}

.dia-plano-excedente {
  background: #2196f3 !important;
  color: #fff !important;
  font-weight: 600;
}

/* Dia clicável no calendário do plano */
.dia-plano-clicavel {
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}

.dia-plano-clicavel:hover {
  transform: scale(1.15);
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  z-index: 1;
}

/* Legenda do Plano */
.legenda-plano {
  display: flex;
  gap: 25px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 15px 0;
  background: #fff;
  border-radius: 8px;
  margin-top: 15px;
}

.legenda-plano-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 0.85rem;
}

.legenda-plano-cor {
  width: 18px;
  height: 18px;
  border-radius: 4px;
}

.bg-previsto-plano {
  background: #c084fc;
}

.bg-executado-plano {
  background: #34d399;
}

.bg-nao-executado-plano {
  background: #f87171;
}

.bg-incompleto-plano {
  background: #ffeb3b;
}

.bg-ferias-plano {
  background: #ff9800;
}

.bg-excedente-plano {
  background: #2196f3;
}

/* Calendário do mês - tamanho maior */
.calendario-mes-maior {
  background: #fff;
  border-radius: 10px;
  padding: 20px 25px;
  min-width: 280px;
  max-width: 320px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border: 1px solid #e9ecef;
}

.calendario-mes-maior .calendario-plano-header {
  font-size: 1.1rem;
  margin-bottom: 15px;
}

.calendario-mes-maior .calendario-plano-dias-header {
  font-size: 0.8rem;
  margin-bottom: 10px;
}

.calendario-mes-maior .calendario-plano-grid {
  gap: 5px;
  font-size: 0.85rem;
}

.calendario-mes-maior .calendario-plano-grid span {
  padding: 6px 4px;
  min-width: 28px;
  min-height: 28px;
}

/* ========== CALENDÁRIO DO MÊS GRANDE ========== */
.calendario-mes-grande-container {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #dee2e6;
}

.calendario-mes-grande-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 10px;
}

.calendario-mes-grande-dias-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-bottom: none;
}

.calendario-mes-grande-dias-header .dia-header {
  text-align: center;
  padding: 12px 8px;
  font-weight: 600;
  font-size: 0.85rem;
  color: #495057;
  background: #f8f9fa;
  border-right: 1px solid #dee2e6;
}

.calendario-mes-grande-dias-header .dia-header:last-child {
  border-right: none;
}

.calendario-mes-grande-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  background: #dee2e6;
  border: 1px solid #dee2e6;
}

.dia-mes-grande {
  background: #fff;
  min-height: 90px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.dia-mes-grande .dia-numero {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.dia-mes-grande .dia-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dia-mes-grande .badge {
  font-size: 0.7rem;
  padding: 4px 8px;
  border-radius: 4px;
}

.dia-mes-grande .badge.bg-previsto {
  background-color: #a855f7 !important;
  color: #fff;
}

/* Classes para os dias */
.dia-mes-grande.dia-vazio {
  background: #f8f9fa;
}

.dia-mes-grande.dia-fora-periodo {
  background: #f8f9fa;
}

.dia-mes-grande.dia-fora-periodo .dia-numero {
  color: #ccc;
}

.dia-mes-grande.dia-executado {
  background: linear-gradient(135deg, #d4edda, #c3e6cb);
  border-left: 4px solid #28a745;
}

.dia-mes-grande.dia-nao-executado {
  background: linear-gradient(135deg, #f8d7da, #f5c6cb);
  border-left: 4px solid #dc3545;
}

.dia-mes-grande.dia-previsto {
  background: linear-gradient(135deg, #e8daef, #d7bde2);
  border-left: 4px solid #a855f7;
}

.dia-mes-grande.dia-incompleto {
  background: linear-gradient(135deg, #fff9c4, #fff59d);
  border-left: 4px solid #ffeb3b;
}

.dia-mes-grande.dia-ferias {
  background: linear-gradient(135deg, #ffe0b2, #ffcc80);
  border-left: 4px solid #ff9800;
}

.dia-mes-grande.dia-excedente {
  background: linear-gradient(135deg, #bbdefb, #90caf9);
  border-left: 4px solid #2196f3;
}

.dia-mes-grande.dia-normal {
  background: #fff;
}

/* Dia clicável no calendário grande */
.dia-mes-grande.dia-clicavel {
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}

.dia-mes-grande.dia-clicavel:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  z-index: 1;
}

/* Responsivo para telas menores */
@media (max-width: 768px) {
  .calendario-mes-grande-dias-header .dia-header {
    font-size: 0.7rem;
    padding: 8px 4px;
  }

  .dia-mes-grande {
    min-height: 60px;
    padding: 4px;
  }

  .dia-mes-grande .dia-numero {
    font-size: 0.9rem;
  }

  .dia-mes-grande .badge {
    font-size: 0.6rem;
    padding: 2px 4px;
  }
}

/* ✅ Estilos para o select de status no calendário */
.status-select-dia {
  font-size: 0.7rem;
  padding: 2px 4px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  width: 100%;
  max-width: 100px;
  text-align: center;
  font-weight: 500;
  text-align-last: center;
}

.status-select-dia:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);
}

/* Opções do dropdown - fundo branco para todas */
.status-select-dia option {
  background-color: #fff !important;
  color: #333 !important;
  font-weight: normal;
  padding: 8px;
}

/* Cores de fundo baseadas no status - cores sólidas para melhor compatibilidade */
.status-select-none {
  background-color: #fff;
  color: #666;
}

.status-select-scheduled {
  background-color: #a855f7;
  color: #fff;
  border-color: #a855f7;
}

.status-select-executed {
  background-color: #28a745;
  color: #fff;
  border-color: #28a745;
}

.status-select-incomplete {
  background-color: #ffeb3b;
  color: #333;
  border-color: #ffeb3b;
}

.status-select-not-executed {
  background-color: #dc3545;
  color: #fff;
  border-color: #dc3545;
}

.status-select-excess {
  background-color: #2196f3;
  color: #fff;
  border-color: #2196f3;
}

.status-select-vacation {
  background-color: #ff9800;
  color: #fff;
  border-color: #ff9800;
}

/* === Botão de Observação no dia === */
.btn-note-dia {
  background: #e9ecef;
  border: 1.5px solid #adb5bd;
  color: #6c757d;
  cursor: pointer;
  font-size: 0.82rem;
  padding: 4px 7px;
  margin-top: 4px;
  border-radius: 6px;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}
.btn-note-dia:hover {
  color: #fff;
  background: #4f46e5;
  border-color: #4f46e5;
  transform: scale(1.1);
}
.btn-note-dia.has-note {
  background: #fff3cd;
  border-color: #f59e0b;
  color: #d97706;
  font-weight: 600;
}
.btn-note-dia.has-note:hover {
  background: #f59e0b;
  color: #fff;
  border-color: #d97706;
}

/* === Modal de Observação === */
.note-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
}
.note-modal {
  background: #fff;
  border-radius: 14px;
  width: 92%;
  max-width: 500px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: noteSlideIn 0.25s ease;
}
@keyframes noteSlideIn {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
.note-modal-header {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: #fff;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
}
.note-modal-header strong {
  font-size: 1rem;
}
.note-modal-date {
  flex: 1;
  text-align: right;
  font-size: 0.78rem;
  opacity: 0.85;
  text-transform: capitalize;
}
.btn-close-note {
  background: rgba(255,255,255,0.15);
  border: none;
  color: #fff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  margin-left: 8px;
}
.btn-close-note:hover {
  background: rgba(255,255,255,0.3);
}
.note-modal-body {
  padding: 18px;
}
.note-textarea {
  width: 100%;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 0.88rem;
  color: #344767;
  resize: vertical;
  min-height: 100px;
  transition: border-color 0.2s;
  font-family: inherit;
}
.note-textarea:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
}
.note-textarea::placeholder {
  color: #a0aec0;
  font-size: 0.82rem;
}
.note-char-count {
  text-align: right;
  font-size: 0.72rem;
  color: #a0aec0;
  margin-top: 4px;
}
.note-modal-footer {
  padding: 12px 18px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid #f1f5f9;
  background: #fafbfc;
}

/* === Botões de ação do dia (nota + exercícios) === */
.dia-acoes-btns {
  display: flex;
  gap: 4px;
  justify-content: center;
  margin-top: 3px;
}

/* === Botão Ver Exercícios === */
.btn-exercicios-dia {
  background: #e0e7ff;
  border: 1.5px solid #818cf8;
  color: #4f46e5;
  cursor: pointer;
  font-size: 0.82rem;
  padding: 4px 7px;
  border-radius: 6px;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-exercicios-dia:hover {
  background: #4f46e5;
  color: #fff;
  border-color: #4f46e5;
  transform: scale(1.1);
}

/* === Modal de Exercícios === */

/* Responsivo */
@media (max-width: 768px) {
  .status-select-dia {
    font-size: 0.6rem;
    padding: 1px 2px;
    max-width: 70px;
  }
  .btn-note-dia,
  .btn-exercicios-dia {
    font-size: 0.7rem;
    padding: 3px 5px;
  }
  .note-modal {
    width: 96%;
    max-width: none;
  }
  .dia-acoes-btns {
    gap: 2px;
  }
}
</style>
